import useSWR from "swr";
import { fetcher, fmt, fmtPx } from "@/lib/api";

export function OrderBook({ symbol }) {
  const { data } = useSWR(symbol ? `/market/depth?symbol=${symbol}&limit=12` : null, fetcher, { refreshInterval: 4000 });
  if (!data) return <div className="panel p-3 text-xs text-[#5e6673]">Loading depth…</div>;
  const maxQ = Math.max(...data.bids.map((b) => b[1]), ...data.asks.map((a) => a[1])) || 1;
  const spread = data.asks[0][0] - data.bids[0][0];
  const row = (p, q, side) => (
    <div key={`${side}${p}`} className="relative flex justify-between mono text-[11px] px-2 py-[2px]">
      <div className={`absolute inset-y-0 right-0 ${side === "bid" ? "bg-[rgba(14,203,129,0.10)]" : "bg-[rgba(246,70,93,0.10)]"}`} style={{ width: `${(q / maxQ) * 100}%` }} />
      <span className={`relative ${side === "bid" ? "up" : "down"}`}>{fmtPx(p)}</span><span className="relative text-[#eaecef]">{fmt(q, 4)}</span>
    </div>
  );
  return (
    <div className="panel p-2" data-testid="order-book">
      <div className="panel-title px-2 mb-1">Order Book · {symbol}</div>
      <div className="flex flex-col-reverse">{data.asks.slice(0, 10).map(([p, q]) => row(p, q, "ask"))}</div>
      <div className="mono text-[11px] text-center py-1 border-y border-[#2b3139] text-[#848e9c]">spread <span className="text-white">{fmtPx(spread)}</span> ({((spread / data.asks[0][0]) * 100).toFixed(3)}%)</div>
      <div>{data.bids.slice(0, 10).map(([p, q]) => row(p, q, "bid"))}</div>
    </div>
  );
}
